import type { Language } from './types';
import { DEFAULT_LANGUAGE } from './types';

/**
 * BCP-47 tags for `Intl` / `toLocale*String` date and time formatting.
 *
 * Date formatting must follow the resident's APP language, never the device
 * locale. Calling `toLocaleDateString([])` — or omitting the locale entirely —
 * makes the runtime fall back to the WebView's own locale, which on our fleet is
 * whatever the tablet happened to be provisioned with. That is how Dutch
 * residents ended up reading "Thursday 31 July" on the standby screen.
 *
 * Belgian variants are deliberate (this is a Belgian operator), and `en-GB`
 * keeps day-before-month ordering instead of the US convention.
 */
export const DATE_LOCALES: Record<Language, string> = {
  en: 'en-GB',
  nl: 'nl-BE',
  fr: 'fr-BE',
  de: 'de-DE',
};

/** Resolve an app language to the locale used for date/time formatting. */
export function dateLocale(lang: Language): string {
  return DATE_LOCALES[lang] || DATE_LOCALES[DEFAULT_LANGUAGE];
}
